module.exports = __webpack_public_path__ + "img/twitter.8e6dabd1.svg";